<section class="csm-content-sec">
    <div class="container">
        <div class="csm-content-inner" *ngIf="pageData?.page_content" [innerHtml]="pageData.page_content">
        </div>
    </div>
</section>